<template>
  <div class="fct-grid" v-if="initialColumnDefs.length > 0">
    <download-csv v-if="gridDetails.data && enableCSVExport"
                  :data="transformedData">
      <button class="fct-button primary">Download Data</button>
    </download-csv>
    <div v-if="gridOptions.useExternalFiltering">
      <div class="fct-form-group">
        <label>Page:
          <input class="fct-input"
                 type="number"
                 v-model="page"
                 :min="1"
                 @change="_getData">
        </label>
      </div>
    </div>
    <div class="columns is-hidden-tablet">
      <div class="column">
        <table class="fct-table striped">
          <thead class="primary">
          <tr :style="{height: rowHeight}">
            <th
              @click="sortBy(column)">
              <span v-text="getHeaderDisplayValue(column)">
            </span>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr :style="{height: rowHeight || 'auto'}" :class="{selected: selectedRowIndex === rindex}"
              v-for="(entry, rindex) in sortedData" @click="rowClick(entry, rindex)">
            <data-cell :row="entry"
                       :index="rindex"
                       :column="column"
                       :app-scope="gridDetails.appScope"></data-cell>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="column is-hidden-tablet">
        <carousel :navigationEnabled="true" :maxPerPage="2">
          <slide class="slide-main" v-for="(column, idx) in columns" v-if="idx > 0" :key="'list' + idx"
                 :style="'z-index:' + idx * 100">
            <table class="fct-table striped" :key="'table' + idx">
              <thead class="primary">
              <tr :style="{height: rowHeight || 'auto'}">
                <th
                  @click="sortBy(column)">
                  <span v-text="getHeaderDisplayValue(column)"></span>
                  <span v-show="(sort || {}).arrowsHidden"
                        :class="[{arrow: sortKey == (column.name || column.displayName)}, sortOrders[column.name || column.displayName] > 0 ? 'asc' : 'dsc']">
            </span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr :style="{height: rowHeight || 'auto'}" :class="{selected: selectedRowIndex === rindex}"
                  v-for="(entry, rindex) in sortedData" @click="rowClick(entry, rindex)">
                <data-cell :row="entry"
                           :index="rindex"
                           :column="column"
                           :app-scope="gridDetails.appScope"></data-cell>
              </tr>
              </tbody>
            </table>
          </slide>
        </carousel>
      </div>
    </div>
    <table class="fct-table striped is-hidden-mobile">
      <thead class="primary">
      <tr :style="{height: rowHeight}">
        <th :style="{width: key.width || 'auto'}" v-for="key in columns"
            @click="sortBy(key)">
          <span v-if="key.headerComponent">
                <component :is="key.headerComponent"
                           :app-scope="column.scope || gridDetails.appScope"
                           :column="column"></component>
          </span>
          <span v-else-if="key.html" v-html="key.html"></span>
          <span v-else v-text="getHeaderDisplayValue(key)"></span>
          <span
            :class="[{arrow: sortKey == (key.name || key.displayName)}, sortOrders[key.name || key.displayName] > 0 ? 'asc' : 'dsc']">
          </span>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr :style="{height: rowHeight ||'auto'}" :class="{selected: selectedRowIndex === rindex}"
          v-for="(entry, rindex) in sortedData" @click="rowClick(entry, rindex)">
        <data-cell v-for="column in columns"
                   :row="entry"
                   :index="rindex"
                   :column="column"
                   :app-scope="gridDetails.appScope"
                   :key="'data-cell-' + (column.name || columns.findIndex(c => c === column))"></data-cell>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Vue from 'vue';
import {Carousel, Slide} from '../FctCarousel';
import ActionButtonCell from './components/ActionButtonCell';
import DataCell from "./components/DataCell";
import CheckCell from "./components/CheckCell";
import CheckHeaderCell from "./components/CheckHeaderCell";
import FilterManagerMaker from "../../utils/filterManagerMaker"
import LoadingHandler from "../../mixins/LoadingHandler";

export default {
  mixins: [LoadingHandler],
  props: {
    getData: {
      type: Function,
      default: () => null
    },
    filterManager: {
      type: Object
    },
    includeCheckColumn: {
      type: Boolean,
      default: false
    },
    defaultActiveSlideName: {
      type: String,
    },
    gridDetails: {type: Object},
    preventInitSort: Boolean,
    enableCSVExport: Boolean,
    sort: {
      key: String,
      direction: String,
      arrowsHidden: Boolean
    },
    onRowClick: {
      type: Function,
      default: () => null
    },
    rowHeight: {
      type: String,
      default: '60px'
    },
  },
  components: {Carousel, Slide, DataCell, CheckHeaderCell},
  data() {
    var sortOrders = {};


    this.gridDetails.columnDefs.forEach(function (key) {
      sortOrders[key.name || key.displayName] = 1;
    });

    return {
      initialColumnDefs: [],
      sortKey: '',
      transform: val => val,
      sortOrders: sortOrders,
      selectedRowIndex: null,
      page: 1
    };
  },
  computed: {
    gridFilterManager: function () {
      return this.filterManager || FilterManagerMaker().createFilterManager(this.gridDetails.data)
    },
    gridOptions: function () {
      return this.gridDetails.options || {}
    },
    columns: function () {
      let columns = this.initialColumnDefs;

      if (this.$store.getters.device.isMobile && this.defaultActiveSlideName) {
        console.log({columns})
        return array_move(columns, columns.findIndex(c => c.name === this.defaultActiveSlideName), 1);
      }

      return [...columns, ...this.optionalColumns];
    },
    optionalColumns() {
      function _makeOptionalColumn({name, click, confirm, iconClass, backgroundColor, color}) {
        return {
          name: '_' + name,
          displayName: ' ',
          width: '60px',
          component: ActionButtonCell,
          events: {click: click},
          bindings: {
            confirm: confirm,
            iconClass: iconClass,
            backgroundColor: backgroundColor,
            color: color
          }
        };
      }

      let optionalColumnsByEvent = {
        removeRow: _makeOptionalColumn({
          name: 'remove',
          click: (row, index) => this.onRemoveBacklinkSite(row, index),
          confirm: 'Confirm Removal',
          iconClass: 'fa fa-trash',
          backgroundColor: '#ff8276',
          color: '#ffeae8'
        }),
        updateRow: _makeOptionalColumn({
          name: 'update',
          click: (row) => this.$emit('updateRow', row),
          iconClass: 'fct-admin-icon-pencil-edit',
          backgroundColor: '#4f79ff',
          color: '#ffeae8'
        })
      };

      return Object.entries(optionalColumnsByEvent)
        .filter(([k]) => this.$listeners[k])
        .map(([_, v]) => v);
    },
    column: function () {
      return this.columns[0];
    },
    sortedData: function () {
      if ((this.gridOptions || {}).useExternalSorting) {
        return this.gridDetails.data
      }

      let {sortKey, transform, getCellValue} = this;
      // var filterKey = this.filterKey && this.filterKey.toLowerCase();

      console.log(this.sortOrders)

      var order = this.sortOrders[sortKey] || 1;
      var data = this.gridDetails.data;
      // if (filterKey) {
      //   data = data.filter(function (row) {
      //     return Object.keys(row).some(function (key) {
      //       return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
      //     });
      //   });
      // }
      if (sortKey) {
        let optionalSortAlgorithm = (this.gridDetails.columnDefs.find((c) => (c.name || c.displayName) === sortKey) || {}).sortAlgorithm;

        data = data.slice().sort(function (a, b) {
          let castStringIfNeeded = (val) => optionalSortAlgorithm ? val : (val === 0 || val) && val.toString();
          let transformAndCastIfNumber = (val) => transform ? transform(castStringIfNeeded(val)) : castStringIfNeeded(getCellValue(sortKey, val));

          a = transformAndCastIfNumber(a);
          b = transformAndCastIfNumber(b);

          if (!a) {
            return -order;
          }

          if (!b) {
            return order;
          }

          let defaultSortAlgorithm = (a, b) => a.localeCompare(b, 'en-US-u-kn-true');

          return (optionalSortAlgorithm || defaultSortAlgorithm)(a, b) * order;
        });
      }

      return data;
    },
    transformedData() {
      const {capitalize, unsnake} = this.$options.filters;
      let transformedData = [];
      for (let entry of this.sortedData) {
        let rowData = {};
        for (let column of this.gridDetails.columnDefs) {
          const columnName = column.displayName || capitalize(unsnake(column.name));
          rowData[columnName] = this.getCellValue(column.name, entry);
        }
        transformedData.push(rowData);
      }

      return transformedData;
    }
  },
  methods: {
    getHeaderDisplayValue(column) {
      const {capitalize, unsnake} = this.$options.filters;
      return column.displayName || (capitalize(unsnake(column.name.split('.').slice(-1)[0])))
    },
    getCellValue(key = '', entry = {}) {
      let i = key.indexOf('.');

      if (i === -1) {
        return entry[key];
      }

      return this.getCellValue(key.slice(i + 1), entry[key.slice(0, i)]);
    },
    sortBy(column) {
      let key = column.name || column.displayName;
      let transform = column.transform;

      if (column.sortHidden || column.headerComponent) {
        return;
      }
      this.sortKey = key;
      this.transform = transform;
      this.sortOrders[key] = this.sortOrders[key] * -1;

      if (this.gridOptions.useExternalSorting) {
        this._sortChangeHandler()
        // return this.$emit('sortChanged', this.sortOrders)
      }
    },
    _sortChangeHandler() {
      // let sort = sortCols.map((c) => [c.field, c.sort.direction])
      // if (sort.length === 0)
      //   sort = (vm.sortOptions)

      return this.gridFilterManager.setSort([{field: this.sortKey, direction: this.sortOrders[this.sortKey]}]);
    },
    rowClick: function (entity, index) {
      this.selectedRowIndex = index;
      this.$emit('rowSelect', entity);
    },
    async onRemoveBacklinkSite(row, idx) {
      if (await this.$listeners.removeRow(row)) {
        this.$nextTick(() => {
          const data = this.gridDetails.data;
          data.splice(idx, 1);
        });
      }

      await this._getData()
    },
    initSort() {
      if (this.preventInitSort || this.useExternalSorting) {
        return;
      }

      if (this.sort) {
        this.sortKey = this.sort.key;
        this.sortOrders[this.sortKey] = this.sort.direction === 'desc' ? 1 : -1;
      } else {
        this.sortKey = this.columns[this.includeCheckColumn ? 1 : 0].name;
      }

      this.sortBy(this.columns.find(c => c.name === this.sortKey));
    },

    async _resetData() {
      await this._getData({reset: true, page: 1})
    },

    async _getData({page = this.page, reset = false} = {}) {
      this.page = page

      await this.withLoading(async () => {
        await this.getData({page, reset});
      })
    }
  },
  filters: {
    cellFilter: function (val, type, input) {
      return type ? Vue.options.filters[type](val, input) : val;
    }
  }, mounted() {
    this.initialColumnDefs.push(...this.gridDetails.columnDefs)

    if (this.includeCheckColumn) {
      this.initialColumnDefs.unshift({
        name: '_check',
        width: '100px',
        component: CheckCell,
        headerComponent: CheckHeaderCell,
        appScope: this
      })
    }
    this.initSort();
    if (this.gridOptions.useExternalFiltering) {
      this.gridFilterManager.addQueryListener(() => this._resetData());
    } else {
      this.gridFilterManager.addListener((data) => this.gridOptions.data = data);
    }
  }
};

function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
};
</script>

<style scoped lang="scss">
@import "../../../sass/fct/variables";
@import '../../../node_modules/bulma/sass/utilities/mixins';

table {
  page-break-inside: auto
}

tr {
  page-break-inside: avoid;
  page-break-after: auto
}

.columns {
  display: flex;
  align-items: flex-end;
  overflow-x: visible;

  .column {
    display: inline-block !important;
    float: left;
    padding: 0;

    width: 50%;
    overflow: hidden;

    .slide-main {
      overflow: hidden;
    }

    &:first-child {
      box-shadow: 4px 0px 8px rgba(66, 66, 66, 0.05);
      z-index: 100;
    }
  }
}

table {
  table-layout: fixed;
}

th, td {
  vertical-align: middle;

  > div {
    text-overflow: ellipsis;
  }
}

th {
  position: relative;

  .arrow {
    position: absolute;
    top: 45%;
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 0;
    margin-left: 5px;

    &.asc {
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 6px solid $active-color;
      transform: translateY(-3px);
      top: 50%;

    }

    &.dsc {
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 6px solid $active-color;
    }
  }

  cursor: pointer;

  &.active .arrow {
    opacity: 1;
  }
}
</style>
